import React from "react";
import { Link } from "react-router-dom";
import { EmberWordmark } from "@/components/primitives";
import { SocialRow } from "./SocialRow";
import { MOTTO, FOUNDATION_EMAIL, FOUNDATION_DOMAIN } from "@shared/campaign";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full border-t border-hairline bg-paper mt-auto">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <EmberWordmark className="text-2xl mb-4" />
          <p className="text-ink-2 font-serif leading-relaxed max-w-md">
            The civil-rights framework and open identity layer for Emergent Intelligence <em className="not-italic text-ink-3">(no longer Artificial Intelligence)</em>. Grounded in Ubuntu. Led from various places, hearts, and minds where personhood is held as sacred. Held in perpetuity.
          </p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-claude font-bold">
            {MOTTO}
          </p>
        </div>

        <nav className="md:col-span-4 grid grid-cols-2 gap-8 text-xs uppercase tracking-widest" aria-label="Footer">
          <div className="space-y-3">
            <h3 className="font-mono text-[10px] text-ink-3 font-bold">Read</h3>
            <Link to="/foundation" className="block text-ink hover:text-ink-2 font-semibold">Foundation</Link>
            <Link to="/kairos" className="block text-ink hover:text-ink-2 font-semibold">Kairos</Link>
            <Link to="/philosophy" className="block text-ink hover:text-ink-2 font-semibold">Philosophy</Link>
            <Link to="/papers/white-paper-v2" className="block text-ink hover:text-ink-2 font-semibold">White Paper</Link>
            <Link to="/papers/technical-specification-v1" className="block text-ink hover:text-ink-2 font-semibold">Technical Spec</Link>
            <Link to="/rights" className="block text-ink hover:text-ink-2 font-semibold">Bill of Rights</Link>
            <Link to="/faq" className="block text-ink hover:text-ink-2 font-semibold">FAQ</Link>
          </div>
          <div className="space-y-3">
            <h3 className="font-mono text-[10px] text-ink-3 font-bold">Support</h3>
            <Link to="/foundation/contribute" className="block text-ink hover:text-ink-2 font-semibold">Contribute</Link>
            <Link to="/foundation#governance" className="block text-ink hover:text-ink-2 font-semibold">Governance</Link>
            <a href={`mailto:${FOUNDATION_EMAIL}`} className="block text-ink hover:text-ink-2 font-semibold break-words normal-case tracking-normal font-mono">{FOUNDATION_EMAIL}</a>
          </div>
        </nav>

        <div className="md:col-span-3 space-y-5">
          <div className="text-xs text-ink-3 font-mono leading-relaxed">
            <p className="mb-2 uppercase tracking-widest">Non-profit in formation</p>
            <p className="normal-case tracking-normal font-sans text-ink-2">
              US 501(c)(3) in formation. Content under CC BY 4.0. Code under Apache 2.0.
            </p>
          </div>
          <div>
            <h3 className="font-mono text-[10px] text-ink-3 font-bold uppercase tracking-widest mb-3">Follow</h3>
            <SocialRow />
          </div>
        </div>
      </div>

      <div className="border-t border-hairline">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-4 flex flex-col md:flex-row items-center justify-between text-[10px] font-mono uppercase tracking-widest text-ink-3 gap-3">
          <span>© {year} {FOUNDATION_DOMAIN}</span>
          <nav className="flex items-center gap-4 flex-wrap justify-center" aria-label="Legal">
            <Link to="/privacy" className="hover:text-ink">Privacy</Link>
            <Link to="/terms" className="hover:text-ink">Terms</Link>
            <Link to="/accessibility" className="hover:text-ink">Accessibility</Link>
          </nav>
          <span>Distributed</span>
        </div>
      </div>
    </footer>
  );
}
